import React from 'react'
import styles from './Frame.module.css'
import Header from './Header/Header'
import Sidebar from './Sidebar/Sidebar'
import Main from './Main/Main'

const Frame = (props) => {
    const {
        headerComponent=true, 
        title, 
        titleColor, 
        headerBackground, 
        headerPadding, 
        headerBorderBottom,
  sidebarWidth,
  collapsedSidebarWidth,
        headerHeight,
  useSidebarToggle,
  mainBackground
    } = props
  return (
  <div className={styles.frameRoot}>
      <Header
        headerComponent={headerComponent}
        title={title}
        titleColor={titleColor}
        headerBackground={headerBackground}
        headerPadding={headerPadding}
        headerBorderBottom={headerBorderBottom}
        headerHeight={headerHeight}
      />
      <div className={styles.layout}>
        <Sidebar
          sidebarWidth={sidebarWidth}
          collapsedSidebarWidth={collapsedSidebarWidth}
          headerHeight={headerHeight}
          headerPadding={headerPadding}
          useSidebarToggle={useSidebarToggle}
        />
  <div className={styles.mainArea} style={{ '--main-background': mainBackground }}>
          <Main>{props.children}</Main>
        </div>
      </div>
    </div>
  )
}

export default Frame
